import { WorkflowPhase, WorkspaceCode } from '@atlas/types'

/**
 * Human labels + fixed per-phase colors shared by every surface that shows a
 * phase: the workflow-admin tables, the builder, and the work-order state timeline.
 */
export const PHASE_LABEL: Record<WorkflowPhase, string> = {
	[WorkflowPhase.INTAKE]: 'Intake',
	[WorkflowPhase.PRODUCTION]: 'Production',
	[WorkflowPhase.VALIDATION]: 'Validation',
	[WorkflowPhase.DELIVERY]: 'Delivery',
}

/** Each phase keeps one fixed color everywhere it appears — never conditional on "current". */
export const PHASE_TAG_CLASS: Record<WorkflowPhase, string> = {
	[WorkflowPhase.INTAKE]: 'bg-ds-surface text-ds-text-subtle',
	[WorkflowPhase.PRODUCTION]: 'bg-ds-info/10 text-ds-info',
	[WorkflowPhase.VALIDATION]: 'bg-ds-warning/10 text-ds-warning',
	[WorkflowPhase.DELIVERY]: 'bg-ds-success/10 text-ds-success',
}

export const PHASE_RING_CLASS: Record<WorkflowPhase, string> = {
	[WorkflowPhase.INTAKE]: 'border-ds-border',
	[WorkflowPhase.PRODUCTION]: 'border-ds-info',
	[WorkflowPhase.VALIDATION]: 'border-ds-warning',
	[WorkflowPhase.DELIVERY]: 'border-ds-success',
}

export const WORKSPACE_CODE_LABEL: Record<WorkspaceCode, string> = {
	[WorkspaceCode.QUEUE_CARD]: 'Queue card',
	[WorkspaceCode.RESOLUTION]: 'Resolution',
	[WorkspaceCode.PRODUCTION]: 'Production',
	[WorkspaceCode.VALIDATION]: 'Validation',
	[WorkspaceCode.DISTRIBUTION]: 'Distribution',
	[WorkspaceCode.SUMMARY]: 'Summary',
}
